

















import { EntityType } from '@/store/entityModules/types';
import EntityTable from '@/components/common/EntityTable.vue';
import { defineComponent, reactive } from '@vue/composition-api';

const Component = defineComponent({
  name: 'FontsTable',

  components: {
    EntityTable,
  },

  setup() {
    const entityType = EntityType.FONT;

    const state = reactive({
      headers: [
        { text: 'Font', value: 'name', sortable: false, editable: false },
        { text: 'Font Groups', value: 'fontGroups', sortable: false, editable: true },
      ],
    });

    return {
      entityType,
      state,
    };
  },
});
export default Component;
